import React from 'react';
import {BrowserRouter} from 'react-router-dom';

import Login from "./sections/auth/LoginSection";
import Layout from './layouts/Layout';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './resources/sass/global.scss';
import {AppProvider} from "./AppContext";

const App = () => {
    return (
        <BrowserRouter>
            <AppProvider>
                {window.location.pathname !== '/auth/login' && <Layout/>}
                {window.location.pathname === '/auth/login' && <Login/>}
            </AppProvider>
        </BrowserRouter>
    )
}

export default App;
